import React, { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import customerSvg from 'assets/singleTicket/customerSvg.svg';
import nestedIndicator from 'assets/singleTicket/nested-indicator.svg';
import { getLeadById } from 'features/newsales/newsalesActions';
import { selectLeadById, selectLeadByIdLoading } from 'features/newsales/newsalesSlice';
import { getCustomerData } from 'features/projectManagement/ProjectManagementActions';
import {
  selectCustomerData,
  selectCustomerDataLoading,
} from 'features/projectManagement/ProjectManagementSlice';

import {
  ContractItem,
  ContractsList,
  CustomerInfoText,
  CustomerInfoWrapper,
  FieldItemRow,
  NestedIcon,
} from './CustomerInfo.styles';

const CustomerInfo = ({ customerId, leadId }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const customerData = useSelector(selectCustomerData);
  const customerLoading = useSelector(selectCustomerDataLoading);
  const leadData = useSelector(selectLeadById);
  const leadLoading = useSelector(selectLeadByIdLoading);

  useEffect(() => {
    if (customerId && customerId !== 'null') {
      dispatch(getCustomerData(customerId));
    }
  }, [dispatch, customerId]);

  useEffect(() => {
    if (!leadId || leadId === 'null') return;
    dispatch(getLeadById(leadId));
  }, [dispatch, leadId]);

  const handleNavigate = (id) => {
    navigate(`/customer-relationship-management/${id}`);
  };

  const handleNavigateToLead = (id) => {
    navigate(`/lead-info?id=${id}`);
  };

  if (leadId && leadId !== 'null') {
    const fullName = [leadData?.firstName, leadData?.lastName, leadData?.patronymic]
      .filter(Boolean)
      .join(' ');
    return (
      <CustomerInfoWrapper>
        <FieldItemRow>
          <NestedIcon src={customerSvg} alt="lead" />
          <CustomerInfoText onClick={() => handleNavigateToLead(leadId)}>
            {leadLoading
              ? 'Loading lead data...'
              : leadData
                ? `Lead #${leadData.leadNumber}${fullName ? `, ${fullName}` : ''}${leadData?.phoneNumber ? `: +${leadData.phoneNumber}` : ''}`
                : `Lead ID: ${leadId}`}
          </CustomerInfoText>
        </FieldItemRow>
      </CustomerInfoWrapper>
    );
  }

  if (!customerId || customerId === 'null') return null;

  const hasMultipleContracts = customerData?.contracts && customerData.contracts.length > 1;

  return (
    <CustomerInfoWrapper>
      <FieldItemRow>
        <NestedIcon src={customerSvg} alt="customer" />
        <CustomerInfoText
          $disabled={hasMultipleContracts}
          onClick={() => {
            if (customerData?.contracts && customerData.contracts.length === 1) {
              handleNavigate(customerData.contracts[0]);
            } else if (!customerData?.contracts || customerData.contracts.length === 0) {
              handleNavigate(customerData?.customerId);
            }
          }}
        >
          {customerLoading
            ? 'Loading customer data...'
            : customerData
              ? `Customer ERP ID: ${customerData.customerId}, ${customerData.fullName}: +${customerData.phoneNumbers?.[0] || 'N/A'}`
              : `Customer ERP ID: ${customerId}`}
        </CustomerInfoText>
      </FieldItemRow>
      {hasMultipleContracts && (
        <ContractsList>
          {customerData.contracts.map((contractId, index) => (
            <ContractItem key={contractId} onClick={() => handleNavigate(contractId)}>
              <NestedIcon style={{ marginTop: -12 }} src={nestedIndicator} />
              Contract {index + 1}: {contractId}
            </ContractItem>
          ))}
        </ContractsList>
      )}
    </CustomerInfoWrapper>
  );
};

export default CustomerInfo;
